import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { black } from 'presentations/views/styles/color';
import { ReactNode } from 'react';

export interface Props {
  title: string | ReactNode;
  description?: string;
}
export default function Component(props: Props) {
  return (
    <TitleContainer>
      <BlogTitle>{props.title}</BlogTitle>
      <BlogDescription>{props.description}</BlogDescription>
    </TitleContainer>
  );
}

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 1080px;
  margin: ${spacing(40)} auto;
  ${mediaMax.tablet} {
    margin: ${spacing(24)} auto;
    padding: 0 ${spacing(12)};
    flex-direction: column;
  }
`;
const BlogTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSize(36)};
  font-weight: ${fontWeight('bold')};
  padding-right: ${spacing(32)};
  margin-right: ${spacing(32)};
  border-right: 1px solid ${black};
  white-space: nowrap;
  font-family: 'Noto Sans';
  ${mediaMax.tablet} {
    font-size: ${fontSize(28)};
    border: 0;
    margin-right: 0;
    padding-right: 0;
    margin-bottom: ${spacing(24)};
  }
`;
const BlogDescription = styled.div`
  font-size: ${fontSize(13)};
  font-weight: ${fontWeight('bold')};
  ${mediaMax.tablet} {
    padding: 0 ${spacing(12)};
  }
`;
